module.exports = __webpack_public_path__ + "img/skiing002.83726738.jpg";